import {
  Component,
  OnInit
} from '@angular/core';

import { AdminService } from
  'src/app/services/admin/admin.service';
import { NgIf } from "../../../../node_modules/@angular/common/index";
import { Router } from '@angular/router';


type ClientType =
  | 'GENERAL'
  | 'CORPORATE'
  | 'CALENDAR';


interface CorporateParticipant {

  fullName: string;

  uocIds: Array<number | null>;

  vocIds: Array<number | null>;

  fitTestRequired: boolean;
}


interface CorporateOtherRow {

  values: string[];
}


@Component({
  selector: 'app-x-courses-list',
  templateUrl: './x-courses-list.component.html',
  styleUrl: './x-courses-list.component.scss'
})
export class XCoursesListComponent implements OnInit {
  // Track Book Now submission
  isBookNowSubmitted: boolean = false;

  // Store selected client type
  selectedClientType: ClientType = 'GENERAL';

  // Store all UOC courses
  allUOCCourses: any[] = [];

  // Store all VOC courses
  allVOCCourses: any[] = [];

  // Store participant count
  numberOfParticipants = 1;

  // Store UOC column count
  numberOfUOC = 3;

  // Store VOC column count
  numberOfVOC = 3;

  // Store other row count
  numberOfOtherRows = 1;

  // Store other column numbers
  otherColumns: number[] = [
    1,
    2,
    3,
    4,
    5
  ];


  // Store corporate participants
  participants: CorporateParticipant[] = [];

  // Store corporate other rows
  otherRows: CorporateOtherRow[] = [];

  // Store additional comments
  additionalComments = '';

  // Track corporate booking save state
  isSavingCorporateBooking = false;

  // Store corporate success message
  corporateSuccessMessage = '';

  // Store corporate error message
  corporateErrorMessage = '';

// Store company name
companyName = '';

// Store company email
companyEmail = '';

// Store requested by name
requestedBy = '';

// Store requested by phone
requestedByPhone = '';

// Store onsite supervisor name
onSiteSupervisor = '';

// Store onsite supervisor phone
onSiteSupervisorPhone = '';

// Store site location address
siteLocationAddress = '';

// Store requested date
dateRequested: string =
  new Date()
    .toISOString()
    .split('T')[0];

// Store required training date
dateTrainingRequired = '';

// Store copy of awards requirement
copyOfAwardsRequired:
  'YES' | 'NO' = 'YES';

// Store metro client status
isMetroClient:
  'YES' | 'NO' = 'NO';

// Store Pegasus upload requirement
uploadAwardEvidenceToPegasus:
  'YES' | 'NO' = 'NO';

// Store site locations
siteLocations: any[] = [];

// Track site location loading state
isLoadingSiteLocations = false;

  constructor(
    private adminService:
      AdminService,
    private router: Router
  ) {
  }


  // ============================================================
  // INIT
  // ============================================================

  ngOnInit(): void {

    this.loadUOCCourses();

    this.loadVOCCourses();

    this.resetCorporateForm();

    this.loadSiteLocations();
  }


  // ============================================================
  // UOC COLUMN ARRAY
  // ============================================================

  get uocColumns(): number[] {

    return Array.from(
      {
        length:
          this.numberOfUOC
      },
      (_, index) =>
        index + 1
    );
  }


  // ============================================================
  // VOC COLUMN ARRAY
  // ============================================================

  get vocColumns(): number[] {

    return Array.from(
      {
        length:
          this.numberOfVOC
      },
      (_, index) =>
        index + 1
    );
  }


  // ============================================================
  // CLIENT TYPE
  // ============================================================

  selectClientType(
    type: ClientType
  ): void {

    this.selectedClientType =
      type;
  }


  // ============================================================
  // LOAD UOC COURSES
  // ============================================================

  loadUOCCourses(): void {

    this.adminService
      .getXCourseList('GET_ALL')
      .subscribe({

        next: (response: any[]) => {

          this.allUOCCourses =
            response || [];

          console.log(
            'UOC Courses:',
            this.allUOCCourses
          );
        },


        error: (error) => {

          console.error(
            'Error loading UOC courses:',
            error
          );
        }
      });
  }


  // ============================================================
  // LOAD VOC COURSES
  // ============================================================

  loadVOCCourses(): void {

    this.adminService
      .getXVOCList('GET_ALL')
      .subscribe({

        next: (response: any[]) => {

          this.allVOCCourses =
            response || [];

          console.log(
            'VOC Courses:',
            this.allVOCCourses
          );
        },


        error: (error) => {

          console.error(
            'Error loading VOC courses:',
            error
          );
        }
      });
  }


  // ============================================================
  // CREATE PARTICIPANT
  // ============================================================

  createParticipant():
    CorporateParticipant {

    return {

      fullName:
        '',


      /*
       * Every participant gets their
       * own UOC slots.
       *
       * Default:
       *
       * [
       *   null,
       *   null,
       *   null,
       *   null
       * ]
       */
      uocIds:
        Array(
          this.numberOfUOC
        ).fill(null),


      /*
       * Every participant gets their
       * own VOC slots.
       */
      vocIds:
        Array(
          this.numberOfVOC
        ).fill(null),


      fitTestRequired:
        false
    };
  }


  // ============================================================
  // CREATE OTHER ROW
  // ============================================================

  createOtherRow():
    CorporateOtherRow {

    return {

      /*
       * Five separate values.
       */
      values: [
        '',
        '',
        '',
        '',
        ''
      ]
    };
  }


  // ============================================================
  // UPDATE PARTICIPANT COUNT
  // ============================================================

  updateParticipantCount(): void {

    let count =
      Number(
        this.numberOfParticipants
      );


    if (
      !count ||
      count < 1
    ) {

      count = 1;
    }


    if (count > 100) {

      count = 100;
    }


    this.numberOfParticipants =
      count;


    // Add participant rows.
    while (
      this.participants.length <
      count
    ) {

      this.participants.push(
        this.createParticipant()
      );
    }


    // Remove participant rows.
    while (
      this.participants.length >
      count
    ) {

      this.participants.pop();
    }
  }


  // ============================================================
  // UPDATE UOC COUNT
  // ============================================================

  updateUOCCount(): void {

    let count =
      Number(
        this.numberOfUOC
      );


    if (
      !count ||
      count < 1
    ) {

      count = 1;
    }


    /*
     * Screenshot requirement:
     * maximum 5 UOC columns.
     */
    if (count > 5) {

      count = 5;
    }


    this.numberOfUOC =
      count;


    /*
     * Update UOC slots for
     * EVERY participant.
     */
    this.participants
      .forEach(
        participant => {


          // Add slots.
          while (
            participant
              .uocIds
              .length <
            count
          ) {

            participant
              .uocIds
              .push(
                null
              );
          }


          // Remove slots.
          while (
            participant
              .uocIds
              .length >
            count
          ) {

            participant
              .uocIds
              .pop();
          }

        }
      );
  }


  // ============================================================
  // UPDATE VOC COUNT
  // ============================================================

  updateVOCCount(): void {

    let count =
      Number(
        this.numberOfVOC
      );


    if (
      !count ||
      count < 1
    ) {

      count = 1;
    }


    if (count > 10) {

      count = 10;
    }


    this.numberOfVOC =
      count;


    /*
     * Update VOC slots for
     * EVERY participant.
     */
    this.participants
      .forEach(
        participant => {


          // Add slots.
          while (
            participant
              .vocIds
              .length <
            count
          ) {

            participant
              .vocIds
              .push(
                null
              );
          }


          // Remove slots.
          while (
            participant
              .vocIds
              .length >
            count
          ) {

            participant
              .vocIds
              .pop();
          }

        }
      );
  }


  // ============================================================
  // UPDATE OTHER ROW COUNT
  // ============================================================

  updateOtherRows(): void {

    let count =
      Number(
        this.numberOfOtherRows
      );


    if (
      isNaN(count) ||
      count < 0
    ) {

      count = 0;
    }


    if (count > 10) {

      count = 10;
    }


    this.numberOfOtherRows =
      count;


    // Add rows.
    while (
      this.otherRows.length <
      count
    ) {

      this.otherRows.push(
        this.createOtherRow()
      );
    }


    // Remove rows.
    while (
      this.otherRows.length >
      count
    ) {

      this.otherRows.pop();
    }
  }


  // ============================================================
  // ADD PARTICIPANT
  // ============================================================

  addParticipant(): void {

    this.participants.push(
      this.createParticipant()
    );


    this.numberOfParticipants =
      this.participants.length;
  }


  // ============================================================
  // REMOVE PARTICIPANT
  // ============================================================

  removeParticipant(
    index: number
  ): void {

    /*
     * Keep at least one participant.
     */
    if (
      this.participants.length <= 1
    ) {

      return;
    }


    this.participants.splice(
      index,
      1
    );


    this.numberOfParticipants =
      this.participants.length;
  }


  // ============================================================
  // ADD OTHER ROW
  // ============================================================

  addOtherRow(): void {

    this.otherRows.push(
      this.createOtherRow()
    );


    this.numberOfOtherRows =
      this.otherRows.length;
  }


  // ============================================================
  // REMOVE OTHER ROW
  // ============================================================

  removeOtherRow(
    index: number
  ): void {

    this.otherRows.splice(
      index,
      1
    );


    this.numberOfOtherRows =
      this.otherRows.length;
  }


  // ============================================================
  // TRACK BY INDEX
  // ============================================================

  /*
   * Important for editable primitive
   * string arrays.
   *
   * Prevents Angular from mixing
   * the 5 "Other" input controls.
   */
  trackByIndex(
    index: number
  ): number {

    return index;
  }

  // ============================================================
  // Back
  // ============================================================

  backForm(): void {
    this.isBookNowSubmitted = false;
  }


  // ============================================================
  // RESET
  // ============================================================

  resetCorporateForm(): void {

    this.isBookNowSubmitted = false;
    // ==========================================================
    // CORPORATE CLIENT DETAILS
    // ==========================================================

    this.companyName = '';

    this.companyEmail = '';

    this.requestedBy = '';

    this.requestedByPhone = '';

    this.onSiteSupervisor = '';

    this.onSiteSupervisorPhone = '';

    this.siteLocationAddress = '';

    this.dateRequested = new Date().toISOString().split('T')[0];

    this.dateTrainingRequired = '';

    this.copyOfAwardsRequired =
      'YES';

    this.isMetroClient =
      'NO';

    this.uploadAwardEvidenceToPegasus =
      'NO';


    // ==========================================================
    // BOOKING CONFIGURATION
    // ==========================================================

    this.numberOfParticipants =
      1;

    this.numberOfUOC =
      3;

    this.numberOfVOC =
      3;

    this.numberOfOtherRows =
      1;


    // ==========================================================
    // TABLE DATA
    // ==========================================================

    this.participants = [
      this.createParticipant()
    ];

    this.otherRows = [
      this.createOtherRow()
    ];

    this.additionalComments =
      '';

    this.corporateSuccessMessage =
      '';

    this.corporateErrorMessage =
      '';
  }


  // ============================================================
  // GET UOC BY ID
  // ============================================================

  getUOCById(
    id: number | null
  ): any {

    if (
      id === null ||
      id === undefined
    ) {

      return null;
    }


    return this
      .allUOCCourses
      .find(
        course =>
          Number(course.id) ===
          Number(id)
      );
  }


  // ============================================================
  // GET VOC BY ID
  // ============================================================

  getVOCById(
    id: number | null
  ): any {

    if (
      id === null ||
      id === undefined
    ) {

      return null;
    }


    return this
      .allVOCCourses
      .find(
        voc =>
          Number(voc.id) ===
          Number(id)
      );
  }


  // ============================================================
  // CREATE CORPORATE BOOKING JSON
  // ============================================================

  createCorporateBookingJson(): any {

    return {

      enquiryType:
        'CORPORATE_BOOKING',

      clientType:
        'CORPORATE',


      // ========================================================
      // CLIENT DETAILS
      // ========================================================

      clientDetails: {

        companyName:
          this.companyName?.trim() || '',

        companyEmail:
          this.companyEmail?.trim() || '',

        requestedBy:
          this.requestedBy?.trim() || '',

        requestedByPhone:
          this.requestedByPhone?.trim() || '',

        onSiteSupervisor:
          this.onSiteSupervisor?.trim() || '',

        onSiteSupervisorPhone:
          this.onSiteSupervisorPhone?.trim() || '',

        siteLocationAddress:
          this.siteLocationAddress?.trim() || '',

        dateRequested:
          this.dateRequested || null,

        dateTrainingRequired:
          this.dateTrainingRequired || null,

        copyOfAwardsRequired:
          this.copyOfAwardsRequired,

        isMetroClient:
          this.isMetroClient,

        uploadAwardEvidenceToPegasus:
          this.isMetroClient === 'YES'
            ? this.uploadAwardEvidenceToPegasus
            : 'NO'
      },


      // ========================================================
      // BOOKING CONFIGURATION
      // ========================================================

      bookingConfiguration: {

        numberOfParticipants:
          this.participants.length,

        numberOfUOC:
          this.numberOfUOC,

        numberOfVOC:
          this.numberOfVOC,

        numberOfOtherRows:
          this.otherRows.length,

        numberOfOtherColumns:
          5
      },


      // ========================================================
      // PARTICIPANTS
      // ========================================================

      participants:
        this.participants.map(
          (
            participant,
            participantIndex
          ) => {

            return {

              participantNo:
                participantIndex + 1,

              fullName:
                participant.fullName.trim(),

              fitTestRequired:
                participant.fitTestRequired,


              // UOC
              uocCourses:
                participant.uocIds
                  .map(
                    (
                      id,
                      uocIndex
                    ) => {

                      const course =
                        this.getUOCById(id);


                      if (!course) {
                        return null;
                      }


                      return {

                        slot:
                          uocIndex + 1,

                        courseId:
                          course.id,

                        courseCode:
                          course.courseCode,

                        courseTitle:
                          course.courseTitle,

                        description:
                          course.description,

                        totalAmount:
                          course.totalAmount,

                        currencyCode:
                          course.currencyCode,

                        documentTypes:
                          course.documentTypes
                      };
                    }
                  )
                  .filter(
                    course =>
                      course !== null
                  ),


              // VOC
              vocCourses:
                participant.vocIds
                  .map(
                    (
                      id,
                      vocIndex
                    ) => {

                      const voc =
                        this.getVOCById(id);


                      if (!voc) {
                        return null;
                      }


                      return {

                        slot:
                          vocIndex + 1,

                        vocId:
                          voc.id,

                        vocCode:
                          voc.vocCode,

                        vocName:
                          voc.vocName,

                        description:
                          voc.description,

                        documentTypes:
                          voc.documentTypes,

                        fkParentCourseId:
                          voc.fkParentCourseId
                      };
                    }
                  )
                  .filter(
                    voc =>
                      voc !== null
                  )
            };
          }
        ),


      // ========================================================
      // OTHER ITEMS
      // ========================================================

      others:
        this.otherRows.map(
          (
            row,
            rowIndex
          ) => {

            return {

              rowNo:
                rowIndex + 1,

              values:
                row.values.map(
                  (
                    value,
                    valueIndex
                  ) => {

                    return {

                      slot:
                        valueIndex + 1,

                      value:
                        value?.trim() || ''
                    };
                  }
                )
            };
          }
        ),


      // ========================================================
      // COMMENTS
      // ========================================================

      additionalComments:
        this.additionalComments?.trim()
        || '',


      createdDate:
        new Date().toISOString()
    };
  }


  // ============================================================
  // VALIDATION
  // ============================================================

  validateCorporateBooking(): boolean {

    this.corporateErrorMessage =
      '';


    if (!this.companyName?.trim()) {

      this.corporateErrorMessage =
        'Please enter the company name.';

      return false;
    }


    if (!this.companyEmail?.trim()) {

      this.corporateErrorMessage =
        'Please enter the requested by company Email.';

      return false;
    }




    const invalidParticipant =
      this.participants.some(
        participant =>
          !participant.fullName?.trim()
      );


    if (invalidParticipant) {

      this.corporateErrorMessage =
        'Please enter the name for every participant.';

      return false;
    }


    return true;
  }


  // ============================================================
  // SAVE CORPORATE BOOKING
  // ============================================================

  sendEnquire(): void {

    this.corporateSuccessMessage =
      '';

    this.corporateErrorMessage =
      '';


    if (
      !this
        .validateCorporateBooking()
    ) {

      return;
    }


    const bookingJson =
      this
        .createCorporateBookingJson();


    console.log(
      'Corporate Booking JSON:',
      bookingJson
    );


    const enquiryModel = {

      id: 0,

      body:
        JSON.stringify(
          bookingJson
        ),

      sentBy:
        this.companyEmail,

      reviewedBy:
        null,

      reviewedDate:
        null,

      isApproved:
        false,

      isActive:
        true,

      clientType: 'CORPORATE'
    };


    this.isSavingCorporateBooking =
      true;


    this.adminService
      .setXEnquiry(
        enquiryModel,
        'INSERT'
      )
      .subscribe({

        next: (response) => {

          console.log(
            'Corporate Booking Response:',
            response
          );


          this.isSavingCorporateBooking =
            false;

          this.resetCorporateForm();
          this.corporateSuccessMessage =
            'Booking details saved successfully.';



          setTimeout(() => {
            this.router.navigate(['/']);
          }, 500);
        },


        error: (error) => {

          console.error(
            'Corporate booking save error:',
            error
          );


          this.isSavingCorporateBooking =
            false;


          this.corporateErrorMessage =
            'Unable to save booking details. Please try again.';
        }
      });
  }
 // Save corporate booking
saveCorporateBooking(): void {

  // Validate course selection
  const isValid =
    this.participants.every(
      participant =>
        participant.uocIds.some(
          id => id !== null
        ) ||
        participant.vocIds.some(
          id => id !== null
        )
    );

  // Handle missing course selection
  if (!isValid) {

    this.corporateErrorMessage =
      'Please select at least 1 course for each participant.';

    return;
  }

  // Check participant names
  const invalidParticipant =
    this.participants.some(
      participant =>
        !participant.fullName?.trim()
    );


  // Handle missing participant name
  if (invalidParticipant) {

    this.corporateErrorMessage =
      'Please enter the name for every participant.';

  }
  else {

    // Reset error message
    this.corporateErrorMessage = "";

    // Mark Book Now submission
    this.isBookNowSubmitted = true;
  }
}


// Check duplicate UOC selection
isUOCSelected(
  participant: CorporateParticipant,
  courseId: number,
  currentIndex: number
): boolean {

  return participant.uocIds.some(
    (selectedId, index) =>
      index !== currentIndex &&
      Number(selectedId) === Number(courseId)
  );
}


// Check duplicate VOC selection
isVOCSelected(
  participant: CorporateParticipant,
  vocId: number,
  currentIndex: number
): boolean {

  return participant.vocIds.some(
    (selectedId, index) =>
      index !== currentIndex &&
      Number(selectedId) === Number(vocId)
  );
}


// Load site locations
loadSiteLocations(): void {

  // Start loading
  this.isLoadingSiteLocations =
    true;

  this.adminService
    .getXSiteLocations(
      'GET_ACTIVE'
    )
    .subscribe({

      next: (response: any[]) => {

        // Store site locations
        this.siteLocations =
          response || [];

        // Stop loading
        this.isLoadingSiteLocations =
          false;
      },

      error: (error) => {

        console.error(
          'Site locations load error:',
          error
        );

        // Reset site locations
        this.siteLocations =
          [];

        // Stop loading
        this.isLoadingSiteLocations =
          false;
      }

    });
}
}